module.exports = __webpack_public_path__ + "img/AL804-1.599260ef.jpg";